import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Aboutus from "./pages/Aboutus";
import ContactF from "./pages/ContactForm";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Career from "./pages/Career";
import FullGallery from "./pages/UI-page";

function App() {
  return (
    <Router>
      <Routes>
        {/* All Page Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/Aboutus" element={<Aboutus />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/ContactForm" element={<ContactF />} />
        <Route path="/Portfolio" element={<Portfolio />} />
        <Route path="/Careers" element={<Career />} />
        <Route path="/ui-page" element={<FullGallery />} />
      </Routes>
      

    </Router>
  );
}

export default App;